import { actionCreator } from './actions';
export const SetQueryAction = 'SetQueryAction';
export const createSetQueryAction = actionCreator(SetQueryAction);
export const SetRequestFilteredQueryAction = 'SetRequestFilteredQueryAction';
export const createSetRequestFilteredQueryAction = actionCreator(SetRequestFilteredQueryAction);
export const SetResponseFilteredQueryAction = 'SetResponseFilteredQueryAction';
export const createSetResponseFilteredQueryAction = actionCreator(SetResponseFilteredQueryAction);
export const SetRequestFilteredEntityTypeAction = 'SetRequestFilteredEntityTypeAction';
export const createSetRequestFilteredEntityTypeAction = actionCreator(SetRequestFilteredEntityTypeAction);
export const SetRequestFilteredLoadingAction = 'SetRequestFilteredLoadingAction';
export const createSetRequestFilteredLoadingAction = actionCreator(SetRequestFilteredLoadingAction);
export const SetRequestFilteredLoadedAction = 'SetRequestFilteredLoadedAction';
export const createSetRequestFilteredLoadedAction = actionCreator(SetRequestFilteredLoadedAction);
